import { PopupAlertModal } from "components/common/modals/PopupAlertModal";
import { useUnsavedChanges } from "contexts/UnsavedChangesContextProvider";
import { doReload } from "functions/doReload";
import { ReactNode } from "react";
import { useTocContext } from "./AppSettingsContext";
import { CLOSE_TOC_NEED_REFRESH, CLOSE_TOC_SAVE_ALERT } from "./toc/interface";

export interface TocContextProviderProps {
  children: ReactNode;
}

/**
 * Thin adapter provider for ToC context.
 * Reads ToC state from the unified AppSettingsContext and re-exposes it.
 *
 * @param params - The component props
 * @param params.children - The child components to render within the provider
 */
export const TocContextProvider = ({ children }: TocContextProviderProps): React.ReactElement => {
  const { state, dispatch } = useTocContext();
  const { navigate } = useUnsavedChanges("toc-context-provider");

  // TODO: This should be moved to the signal-R provider
  return (
    <>
      {children}
      <PopupAlertModal
        id="toc-save-alert"
        show={state.showSaveAlert}
        title="New Major Version Available"
        message="The ToC has been updated and saved as a new version. Please close this Popup to redirect."
        onClose={() => {
          dispatch({ operation: CLOSE_TOC_SAVE_ALERT });
          navigate(`/R/${state.tocIdFromMessage}`);
        }}
      />
      <PopupAlertModal
        id="toc-need-refresh"
        show={state.showNeedRefresh}
        title="Large change made"
        message="The ToC has been updated by someone else/in another browser tab, and needs to be refreshed."
        onClose={() => {
          dispatch({ operation: CLOSE_TOC_NEED_REFRESH });
          doReload();
        }}
      />
    </>
  );
};

TocContextProvider.displayName = "TocContextProvider";

export default TocContextProvider;
